import React from "react";
import T from 'i18n-react'
import CSSModules from 'helpers/CSSModulesUtil'
import styles from './styles.scss'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import CardLoading from 'components/display/CardLoading'
import { 
    nvqualDetailsLoadingSelector,
    currentRevisionSelector,
    nvqualStatusSourceSelector
  } from './selectors';
import { NVQUAL_REPORT_HEADER } from './constants'
import EditBox from './EditBox/index'
import EmptyMessage from './EmptyMessage'
import { ENV } from 'config.js'
import StatusChip from './Chip'
import {
    downloadFiles,
    createNvbugs
} from './actions'
import { FILTER_ALL } from 'containers/Project/Specifications/constants';
import { getMonthDayYear } from 'helpers/DateUtil'
import SpecItem from 'components/custom/SpecItem/index'
import notifyHoc from 'containers/App/Notification/Notify'
import { IconButton } from 'react-toolbox/lib/button'
import { Flex } from 'reflexbox'
import FontIcon from 'react-toolbox/lib/font_icon'


const InfoButton = notifyHoc(FontIcon)


const mapStateToProps = (state) => {
  return {
    isLoading: nvqualDetailsLoadingSelector(state),
    currentRevision: currentRevisionSelector(state),
    nvqualStatusSource: nvqualStatusSourceSelector(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onDownloadFile: (files, name) => dispatch(downloadFiles(files, name, true)),
    createNvbugs: (revisionId) => dispatch(createNvbugs(revisionId, true))
  }
}

class SummaryHeader extends React.Component {

    getStatusText(statusNum){
        const { nvqualStatusSource } = this.props
        const status = nvqualStatusSource.find(x => x.value == statusNum)
        return !status ? "N/A" : status.label
      }

    getNvbugsUrl(nvbugId){
        return ENV == 'production' ? `https://nvbugswb.nvidia.com/NvBugs5/HWBug.aspx?bugid=${nvbugId}`:
        `https://stbugswb.nvidia.com/NvBugs5/HWBug.aspx?bugid=${nvbugId}`
      }

    getFile = (onDownloadFile, file) => {
      return file && <a className={styles.link} onClick={onDownloadFile.bind(this, [file.id], file.name)}>{file.name}</a>
    }

    getNvBugsId = (nvbugId) => {
      const { createNvbugs, currentRevision } = this.props
      if (nvbugId) {
        return <a href={this.getNvbugsUrl(nvbugId)} target="_blank" rel="noopener noreferrer">{nvbugId}</a>
      } else {
        return (
          <Flex className={styles.nvbugsIdWrapper}>
            <div>Not created</div>
            <InfoButton
              value='play_circle_outline'
              message={T.translate('pages.project.view.notification.nvqual_create_nvbugs')}
              onClick={createNvbugs.bind(this, currentRevision.revision.id)}
              className={styles.nvbugsIcon}
            />
          </Flex>
        )
      }
    }

    getStatusChip = (resultId) => (<div className={styles.statusLabel}>
        <StatusChip text={this.getStatusText(resultId)}/>
      </div>)


    renderDisplayRow = (x, index) => {
        const { currentRevision, onDownloadFile } = this.props
        const label = T.translate(`specs.nvqualReportHeader.${x}`);
        let val = currentRevision.revision[x]
        switch(x) {
            case 'curRevNum':
              val = currentRevision.revision.revisionNumber
              break;
            case 'nvqualResultId':
              val = this.getStatusChip(currentRevision.revision.nvqualResultId)
              break;
            case 'createdAt':
              val = getMonthDayYear(new Date(currentRevision.revision[x]))
              break;
            case 'nvbugId':
              const nvBugId = currentRevision.revision[x]
              val = this.getNvBugsId(nvBugId)
              break;
            case 'file':
              val = this.getFile(onDownloadFile, currentRevision.revision[x])
              break;
            default:
              val = currentRevision.revision[x]
              break;
          }

          return (<SpecItem
            key={index}
            label={label}
            initValue={''}
            modifiedValue={val}
            isModifiedPage={false}
            risk={false}
            curFilter={FILTER_ALL}
            curStatus={null}
          />)
    }


  render() {

    const { edit, currentRevision, isLoading } = this.props

    if (isLoading) return (<CardLoading />)

    if (edit) return (<EditBox />)

    if (!currentRevision) return (<EmptyMessage />)


    return (
        <div className={styles.specItemCommon}>
           {NVQUAL_REPORT_HEADER.map((x, index) => {
            return this.renderDisplayRow(x, index)
          })}
        </div>
      )
  }
}

const withStyle = CSSModules(styles)
const withConnect = connect(mapStateToProps, mapDispatchToProps)

const enhance = compose(
  withConnect,
  withStyle,
)

export default enhance(SummaryHeader)
